export default function($) {
  var speed = 90; // ms

  $('.js-nav .menu-item-has-children > a')
    .attr('aria-haspopup', 'true')
    .attr('aria-expanded', 'false');

  $(document).on('mouseenter', '.js-nav .menu-item-has-children', function () {
    $(this).children('a').first().attr('aria-expanded', 'true');
  }).on('mouseleave', '.js-nav .menu-item-has-children', function () {
    var $item = $(this);
    if (!$item.find(':focus').length) {
      $item.children('a').first().attr('aria-expanded', 'false');
    }
  });

  $(document).on('focusin', '.js-nav .menu-item-has-children', function () {
    $(this).children('a').first().attr('aria-expanded', 'true');
  }).on('focusout', '.js-nav .menu-item-has-children', function () {
    var $item = $(this);
    setTimeout(function () {
      if (!$item.find(':focus').length) {
        $item.children('a').first().attr('aria-expanded', 'false');
      }
    }, 0);
  });

  $(document).on('keydown', '.js-nav .menu-item-has-children > a', function (event) {
    if (event.key === ' ' || event.key === 'ArrowDown') {
      event.preventDefault();
      $(this).closest('.menu-item-has-children')
        .find('.sub-menu').first()
        .find('> .menu-item > a').first().focus();
    }
  });

  function openPanel() {
    $('#nav-mobile-panel').addClass('is-open');
    $('body').addClass('nav-mobile-open');
    $('.js-nav-mobile-open').attr('aria-expanded', 'true');
  }

  function closePanel() {
    $('#nav-mobile-panel').removeClass('is-open');
    $('body').removeClass('nav-mobile-open');
    $('.js-nav-mobile-open').attr('aria-expanded', 'false');
  }

  $(document).on('click', '.js-nav-mobile-open', function(event) {
    event.stopPropagation();
    if ($('#nav-mobile-panel').hasClass('is-open')) {
      closePanel();
    } else {
      openPanel();
    }
  });

  $(document).on('keydown', function(event) {
    if (event.key === 'Escape' && $('#nav-mobile-panel').hasClass('is-open')) {
      closePanel();
    }
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });
}
